import { useSnapshot } from "valtio";
import { bookingsStore, configStore, dataListStore } from "../state/CommonState";
import { useEffect, useState } from "react";
import Api from "../state/Api";
import { useFieldArray, useForm } from "react-hook-form";
import Utils from "../util/Utils";
import LabeledSelectField from "../mui-components/LabeledSelectField";
import LabeledTextField from "../mui-components/LabeledTextField";
import { loader } from "../util/loader";
import RoleUtils from "../util/RoleUtils";
import { PERMISSIONS_NEW } from "../util/constants";
import BookingsApi from "../state/bookings-api";
import MonApi, { GET_BOOKINGDSR_BY_FILTER_URI } from "../state/mongo-api";

export function ContainerDetailsForm() {
    useSnapshot(bookingsStore)
    useSnapshot(dataListStore)
    const [disableFields, setDisableFields] = useState(true)
    const [dsrData,setDsrData] = useState([])
    const booking = bookingsStore.current
    const expandContainerList = (containerList) => {
        return (containerList || []).flatMap((container) =>
            Array.from({ length: container.numContainers }, (_, i) => ({
                ...container,
                containerIndex: i + 1,
            }))
        );
    };

    const expandedContainerList = expandContainerList(booking.contract?.containerList);

    useEffect(() => {
        if (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.EDIT_CONTAINER_DETAILS)) {
            setDisableFields(false)
        }
        async function getDSRdata(){
            let dsr = await MonApi.apost(GET_BOOKINGDSR_BY_FILTER_URI, {
                _id: bookingsStore.current?._id
            })
            const dsrRecord = Array.isArray(dsr) ? dsr[0] : []
            if(dsrRecord?.containerlist?.length>0){
                setDsrData(dsrRecord)
                const typeCount = {};

                expandedContainerList.forEach((container, index) => {
                    const type = container.containerType;

                    if (!typeCount[type]) typeCount[type] = 0;
                    const typeIndex = typeCount[type];
                    typeCount[type]++;

                    const matchingDsrContainers = dsrRecord.containerlist.filter(
                        (c) => c.container_types === type
                    );
                    const matchingDsr = matchingDsrContainers[typeIndex];

                    if (matchingDsr) {
                        if (matchingDsr.container_number) {
                            setValue(`containerDetails.${index}.containerNumber`, matchingDsr.container_number);
                        }
                        
                    }
                })
            }
        } 
        getDSRdata()
        
    }, []);

    const { register, control, handleSubmit, setValue, watch } = useForm({
        defaultValues: {
            containerDetails: expandedContainerList.map((e) => ({
                containerType: e.containerType || "",
                containerNumber: e.containerNumber || "",
                extNoOfPieces: e.extNoOfPieces || "",
                intNoOfPieces: e.intNoOfPieces || "",
                grossWeightKg: e.grossWeightKg || "",
                volumeCbm: e.volumeCbm || "",
                netWeight: e.netWeight || "",
            }))
        }
    });

    const { fields } = useFieldArray({
        control,
        name: "containerDetails"
    });

    useEffect(() => {
        BookingsApi.getBooking(bookingsStore.current._id, (data) => {
            if (data?.containerDetails) {
                data.containerDetails.forEach((container, index) => {
                    [
                        "containerType",
                        "containerNumber",
                        "extNoOfPieces",
                        "intNoOfPieces",
                        "grossWeightKg",
                        "volumeCbm",
                        "netWeight",
                    ].forEach((key) => {
                        setValue(`containerDetails.${index}.${key}`, container[key] || "");
                    });
                });
            }
        });
    }, []);

    const onSave = (data) => {
        console.log(data, "checking for this");
        const regex = /^[A-Z]{4}[0-9]{7}$/;
        for (let i = 0; i < data.containerDetails.length; i++) {
            const { containerNumber, containerType } = data.containerDetails[i];

            if (containerNumber && !regex.test(containerNumber)) {
                return configStore.setModalMessage(
                    `Invalid Container Number "${containerNumber}" for ${containerType} (e.g. ABCD1234567)`
                );
            }
        }        
        const payload = {
            id: bookingsStore.current._id,
            type: "containerDetails",
            data: data.containerDetails
        };
        loader.show();
        Api.updateShippingDetails(payload, (data) => {
            bookingsStore.current = data;
            loader.hide();
            configStore.setModalMessage('Container Details Updated Successfully');
            configStore.containerDetails = false;
        });
    };

    return (
        <div style={{ borderRadius: "6px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)", position: "fixed", inset: 0, top: "50px", zIndex: 1000, display: "flex", flexDirection: "column", overflowY: "auto" }}
            className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px] mt-[5px]">
            <div style={{ borderRadius: "6px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)", padding: '18px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h4 className="title">Container Details</h4>
                    <button style={{ float: 'right' }} className="button is-small islink"
                        onClick={() => configStore.containerDetails = false}>
                        <span className="icon">
                            <i className="fas fa-xmark"></i>
                        </span>
                    </button>
                </div>

                <form onSubmit={handleSubmit(onSave)} style={{ padding: "20px" }}>
                    <div style={{ overflowX: "auto" }}>
                        <table className="table is-fullwidth is-bordered is-striped is-hoverable">
                            <thead>
                                <tr>
                                    <th style={{ fontSize: 12, whiteSpace: "nowrap" }}>Container</th>
                                    <th style={{ fontSize: 12, whiteSpace: "nowrap" }}>Container Number</th>
                                    <th style={{ fontSize: 12, whiteSpace: "nowrap" }}>Extl. No. of Pieces</th>
                                    <th style={{ fontSize: 12, whiteSpace: "nowrap" }}>Intl. No. of Pieces</th>
                                    <th style={{ fontSize: 12, whiteSpace: "nowrap" }}>Gross Weight (Kg)</th>
                                    <th style={{ fontSize: 12, whiteSpace: "nowrap" }}>Volume (CBM)</th>
                                    <th style={{ fontSize: 12, whiteSpace: "nowrap" }}>Net Weight</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fields.map((field, index) => (
                                    <tr key={field.id}>
                                        <td>
                                            <input
                                                className="input is-small"
                                                type="text"
                                                disabled
                                                value={
                                                    `${expandedContainerList[index]?.containerType || ""} 
                                                    (${expandedContainerList[index]?.containerIndex}/${expandedContainerList[index]?.numContainers})`
                                                }
                                            />
                                        </td>

                                        {/* Container Number */}
                                        <td>
                                            <input
                                                className="input is-small"
                                                type="text"
                                                disabled={disableFields}
                                                {...register(`containerDetails.${index}.containerNumber`)}
                                                onChange={(e) => {
                                                    setValue(
                                                        `containerDetails.${index}.containerNumber`,
                                                        e.target.value.toUpperCase()
                                                    );
                                                }}
                                            />
                                        </td>

                                        {/* Extl. No. of Pieces */}
                                        <td>
                                            <input
                                                className="input is-small"
                                                type="number"
                                                disabled={disableFields}
                                                {...register(`containerDetails.${index}.extNoOfPieces`)}
                                            />
                                        </td>

                                        {/* Intl. No. of Pieces */}
                                        <td>
                                            <input
                                                className="input is-small"
                                                type="number"
                                                disabled={disableFields}
                                                {...register(`containerDetails.${index}.intNoOfPieces`)}
                                            />
                                        </td>

                                        {/* Gross Weight (kg) */}
                                        <td>
                                            <input
                                                className="input is-small"
                                                type="number"
                                                disabled={disableFields}
                                                {...register(`containerDetails.${index}.grossWeightKg`)}
                                            />
                                        </td>

                                        {/* Volume (Cbm) */}
                                        <td>
                                            <input
                                                className="input is-small"
                                                type="number"
                                                disabled={disableFields}
                                                {...register(`containerDetails.${index}.volumeCbm`)}
                                            />
                                        </td>

                                        {/* Net Weight */}
                                        <td>
                                            <input
                                                className="input is-small"
                                                type="number"
                                                disabled={disableFields}
                                                {...register(`containerDetails.${index}.netWeight`)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div style={{ display: "flex", gap: "10px", justifyContent: 'flex-end', marginTop: '15px' }}>
                        <button
                            style={{ backgroundColor: '#2B3688', color: '#FFFFFF' }}
                            onClick={handleSubmit(onSave)}
                            className="button"
                            disabled={disableFields}
                        >
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}